import { init as initHeroBanner } from './herobanner/front.jsx';

initHeroBanner();
